import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

const getSEODescription = (
  description: string,
  partners?: Array<PartnerFragment> | null,
  enableCoBranding?: boolean
): string => {
  if (partners && partners?.length > 1 && enableCoBranding) {
    return _t(`Offered by #{firstPartnerName} and #{secondPartnerName}. #{description}`, {
      firstPartnerName: partners[0].name,
      secondPartnerName: partners[1].name,
      description,
    });
  } else if (partners?.length === 1) {
    return _t(`Offered by #{firstPartnerName}. #{description}`, {
      firstPartnerName: partners[0].name,
      description,
    });
  } else {
    return description;
  }
};

export default getSEODescription;
